import { ChangeDetectorRef, Component, EventEmitter, forwardRef, Input, OnInit, Output } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { _HttpClient } from '@delon/theme';
import { SelectBaseComponent } from 'src/app/shared-feature/components/select/select-base';

@Component({
  selector: 'app-dealer-select',
  templateUrl: './dealer-select.component.html',
  standalone: false,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DealerSelectComponent),
      multi: true
    }
  ]
})
export class DealerSelectComponent implements OnInit {
  @Input() selected: any;
  dealer: any = [];
  value: any[] = [];
  searching: boolean = false;
  @Output() readonly selectedChange = new EventEmitter();
  constructor(private http: _HttpClient,) {
  }

  ngOnInit(): void {
    this.getDealer()
  }

  getDealer(){
    this.searching = true;
    this.http.get('api/reporting/partners/getDealer').subscribe({
      next: (res: any) => {
        this.dealer = res;
        this.searching = false;
      }
    });
  }

  onChange($event: any[]): void{
    this.selected = $event;
    this.selectedChange.emit(this.selected);
  }
}